// Fuso do navegador para o log de logins da API (ex.: "Europe/Rome").
// Sem fuso disponível, não manda o header: a API usa Europe/Rome.
export function timezoneHeader() {
  try {
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return tz ? { "X-Timezone": tz } : {};
  } catch (e) {
    return {};
  }
}
